import { DeviceAccountInfo } from "./deviceAccountInfo";

/**
 * TEST-ONLY shortcut for the public device registration flow (CM-168).
 *
 * Entering this serial/PIN pair skips the real `getAccountByDeviceSerial` call
 * entirely and returns a canned "everything checks out" response, so the rest
 * of the flow (CM-617 onward) can be developed and demoed without a real
 * device on hand.
 *
 * Deliberately kept out of `getAccountByDeviceSerial` itself and out of
 * `DeviceRegistrationWizard` — this is not part of the real validation logic,
 * only a bypass in front of it. Remove this file (and its use in
 * `getAccountByDeviceSerialForPublicRegistration`) once it is no longer needed
 * for testing.
 */
export const QA_BYPASS_SERIAL = "1234";
export const QA_BYPASS_PIN = "1234";

/** Auto-filled into "Device Location" on the registration screen once the bypass
 *  credentials are typed, so the whole form can be submitted without touching
 *  anything but the serial/PIN fields. */
export const QA_BYPASS_LOCATION = "test device, test room";

export const isQaBypassCredentials = (serial: string, pin: string): boolean =>
  serial === QA_BYPASS_SERIAL && pin === QA_BYPASS_PIN;

export const getQaBypassDeviceAccountInfo = (): DeviceAccountInfo => ({
  isFound: true,
  isAuthenticated: true,
  isConnected: true,
  isRegistered: false,
  isBlocked: false,
  hasProfessionalPackage: true
});
